import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { useCart } from '../context/CartContext';
import { useCurrency } from '../context/CurrencyContext';
import ImageLoop from './ImageLoop';
import StarRating from './StarRating';

export default function ProductCard({ product, index = 0, animateSelf = true }) {
    const { addItem, setDrawerOpen } = useCart();
    const { format } = useCurrency();
    const [hover, setHover] = useState(false);
    const images = (product.images || []).filter(Boolean);

    const onAdd = (e) => {
        e.preventDefault();
        e.stopPropagation();
        addItem({
            product_id: product.id,
            product_slug: product.slug,
            name: product.name,
            price: product.price,
            image: product.images?.[0] || '',
            size: product.sizes?.[0] || '',
            color: product.colors?.[0] || '',
            quantity: 1,
        });
        toast.success(`${product.name} added to your bag.`);
        setDrawerOpen(true);
    };

    return (
        <Link
            to={`/product/${product.slug}`}
            className={`luxury-card group block ${animateSelf ? 'fade-in' : ''}`}
            style={animateSelf ? { animationDelay: `${index * 80}ms` } : undefined}
            data-testid={`product-card-${product.slug}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <div className="image-zoom-wrapper aspect-[4/5] bg-[var(--brand-cream)] relative">
                {images.length > 0 ? (
                    <ImageLoop images={images} playing={hover} className="w-full h-full image-zoom" alt={product.name} testId={`product-card-loop-${product.slug}`} />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-[var(--ink-muted)] text-xs">no image</div>
                )}
                {images.length > 1 && (
                    <span className="absolute top-2 right-2 text-[9px] uppercase tracking-[0.12em] px-2 py-0.5 rounded-full bg-white/85 backdrop-blur" style={{ color: 'var(--brand-burgundy)' }}>{images.length} views</span>
                )}
            </div>
            <div className="p-4 sm:p-5 lg:p-6">
                <h3 className="font-serif text-lg sm:text-xl lg:text-2xl leading-tight" style={{ color: 'var(--brand-burgundy)' }}>
                    {product.name}
                </h3>
                {product.rating_count > 0 && (
                    <div className="mt-1.5 flex items-center gap-1.5">
                        <StarRating value={Math.round(product.rating_avg)} readOnly size={13} />
                        <span className="text-[11px]" style={{ color: 'var(--ink-muted)' }}>{product.rating_avg.toFixed(1)} ({product.rating_count})</span>
                    </div>
                )}
                <div className="mt-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3">
                    <p className="font-serif text-lg lg:text-xl whitespace-nowrap" style={{ color: 'var(--ink)' }}>
                        {format(product.price)}
                    </p>
                    <button
                        onClick={onAdd}
                        data-testid={`product-card-add-to-bag-${product.slug}`}
                        className="btn-blush w-full sm:w-auto px-4 py-2 rounded-full text-[11px] tracking-[0.16em] uppercase font-medium whitespace-nowrap text-center"
                    >
                        Add to Bag
                    </button>
                </div>
            </div>
        </Link>
    );
}
